/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Calc_Row_Notion_NoteInputs */

const en_mk_calc_row_notion_note = /** @type {(inputs: Mk_Calc_Row_Notion_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`US$20 per seat. Custom Agents are billed per credit on top of the plan (US$10 per 1,000 credits).`)
};

const id_mk_calc_row_notion_note = /** @type {(inputs: Mk_Calc_Row_Notion_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`US$20 per kursi. Custom Agents ditagih per kredit di atas paket (US$10 per 1.000 kredit).`)
};

/**
* | output |
* | --- |
* | "US$20 per seat. Custom Agents are billed per credit on top of the plan (US$10 per 1,000 credits)." |
*
* @param {Mk_Calc_Row_Notion_NoteInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_calc_row_notion_note = /** @type {((inputs?: Mk_Calc_Row_Notion_NoteInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Calc_Row_Notion_NoteInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_calc_row_notion_note(inputs)
	return en_mk_calc_row_notion_note(inputs)
});